import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row !important;
  background-color: #f0f4ff;
  padding: 16px 20px 16px 32px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  gap: 12px;
  width: 340px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.5;
`;

const Heading = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

const Subheading = styled.div`
  font-size: 12px;
  line-height: 1.5;
  color: #666;
`;

const StyledButton = styled.button`
  background-color: #3c5dff;
  color: white;
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  height: 36px;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #1a1ec8;
  }
  flex: 1;
`;

const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
type CTAButtonProps = {
  onClick: () => void;
  heading: string;
  subheading: string;
  buttonText: string;
};

export const CTAButton = ({ onClick, heading, subheading, buttonText }: CTAButtonProps) => {
  return (
    <Container>
      <TextContainer>
        <Heading>{heading}</Heading>
        <Subheading>{subheading}</Subheading>
      </TextContainer>
      <ButtonContainer>
        <StyledButton onClick={onClick}>{buttonText}</StyledButton>
      </ButtonContainer>
    </Container>
  );
};
